import React, { createContext, useContext, useState, ReactNode } from 'react'
import { Toast } from '@spoonflower/ui'

type ToastContextType = {
  showToast: (variant: 'success' | 'error' | 'info' | 'warning', content: string, title?: string,  action?: ReactNode, duration?: number) => void
}

const ToastContext = createContext<ToastContextType | undefined>(undefined)

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toast, setToast] = useState<{ variant: 'success' | 'error' | 'info' | 'warning', title: string, content: string, action?: ReactNode, duration?: number } | null>(null)

  const showToast = (variant: 'success' | 'error' | 'info' | 'warning' = 'success', content: string, title?: string, action?: ReactNode, duration?: number) => {
    setToast({ title: title ?? '', content, variant, action, duration })
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && (
        <Toast
          open={!!toast}
          variant={toast.variant}
          title={toast.title}
          content={toast.content}
          duration={toast.duration || 5000}
          onOpenChange={(open) => {
            if (!open) setToast(null)
          }}
          closeButton={!toast.action}
        >
          {toast.action}
        </Toast>
      )}
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast must be used within ToastProvider')
  return context
}